"use strict";
var carbucks = carbucks || {};

carbucks.hero =
  carbucks.hero ||
  (function() {
    function init() {
      var videoOverlayTrigger = document.querySelector(
        "#js-hero-trigger-overlay-video"
      );
      var videoOverlay = document.getElementById("js-hero-video-overlay");
      if (videoOverlay) {
        var theVideo = videoOverlay.getElementsByTagName("video")[0];
      }
      var videoOverlayClose = document.getElementById(
        "js-hero-video-overlay-close"
      );
      var videoBackground = document.getElementById("js-hero-video-background");

      if (videoOverlayTrigger && videoOverlay) {
        videoOverlayTrigger.addEventListener("click", function() {
          videoOverlay.classList.add("hero-video-overlay--visible");
          document.body.classList.add("no-scroll");
          theVideo.play();

          document.addEventListener("keydown", (evt) => {
            if (evt.key === "Escape") {
              videoOverlay.classList.remove("hero-video-overlay--visible");
              document.body.classList.remove("no-scroll");
              theVideo.pause();
            }
          });

          if (videoOverlayClose) {
            videoOverlayClose.addEventListener("click", function() {
              videoOverlay.classList.remove("hero-video-overlay--visible");
              document.body.classList.remove("no-scroll");
              theVideo.pause();
            });
          }
        });
      }
    }
    return {
      init: init,
    };
  })();
